<template>
  <path
    d="M4.19997 17.7803L9.49997 12.4803L12.75 15.7303C13.16 16.1403 13.82 16.1203 14.2 15.6903L21.37 7.62027C21.72 7.23027 21.7 6.63027 21.33 6.25027C20.93 5.85027 20.26 5.86027 19.88 6.29027L13.49 13.4703L10.2 10.1803C9.80997 9.79027 9.17997 9.79027 8.78997 10.1803L2.69997 16.2803C2.30997 16.6703 2.30997 17.3003 2.69997 17.6903L2.78997 17.7803C3.17997 18.1703 3.81997 18.1703 4.19997 17.7803Z"
  />
</template>
